import { Identifiable, Resource, id, resource } from "@planzone/dto";

type PlanzoneContacts = {
  billingContacts: Identifiable<Resource>[];
  decisionMakerContact: Identifiable<Resource>;
  technicalManagerContact: Identifiable<Resource>;
  onboardingContact: Identifiable<Resource>;
};

const planzoneContacts: PlanzoneContacts = {
  decisionMakerContact: { uuid: id, ...resource },
  onboardingContact: { uuid: id, ...resource },
  technicalManagerContact: { uuid: id, ...resource },
  billingContacts: [],
};

export type { PlanzoneContacts };

export { planzoneContacts };
